import { isBrowser } from '../isBrowser';

export function getLocationPath(): string | undefined {
  if (isBrowser()) {
    return `${window.location.pathname}${window.location.search}`;
  }

  return undefined;
}
